import OpticksCard from "@/components/ui/OpticksCard/OpticksCard";
import BrandOAuthIcon from "@/components/ui/OpticksIcons/BrandOAuthIcon";
import Filter2CodeIcon from "@/components/ui/OpticksIcons/Filter2CodeIcon";
import type { IntegrationFlow } from "../ChannelIntegrationGuide.types";
import "./ChooseIntegrationMethod.css";

interface Props {
  selectedFlow: IntegrationFlow;
  onSelectFlow: (flow: IntegrationFlow) => void;
  channelName: string;
}

const ChooseIntegrationMethod = ({
  selectedFlow,
  onSelectFlow,
  channelName,
}: Props) => {
  return (
    <div className="choose-integration-method">
      <OpticksCard
        icon={<BrandOAuthIcon size={48} />}
        onClick={() => onSelectFlow("oauth")}
        selected={selectedFlow === "oauth"}
        recommended
        title="Link account via OAuth"
        description={`Connect your ${channelName} Ads account through OAuth to automate the integration`}
      />
      <OpticksCard
        icon={<Filter2CodeIcon size={48} />}
        onClick={() => onSelectFlow("manual")}
        selected={selectedFlow === "manual"}
        title="Integrate manually"
        description={`Follow a step-by-step guide to manually integrate ${channelName} with Opticks`}
      />
    </div>
  );
};

export default ChooseIntegrationMethod;
